import { lockBody, unlockBody } from "../../../shared/js/helpers/body-lock-toggle";
window.addEventListener('load', () => {
    const stateSelectorModalToggles = document.querySelectorAll('button[data-toggle-state-selector]');
    const stateSelectorModal = document.getElementById('stateSelectorModal');

    if (stateSelectorModalToggles.length && stateSelectorModal) {
        document.addEventListener('click', (event) => {
            const target = event.target;

            function openCloseModal() {
                stateSelectorModal.dataset.active = stateSelectorModal.dataset.active === 'false' ? 'true' : 'false';
                if (stateSelectorModal.dataset.active === 'false') {
                    unlockBody();
                    document.removeEventListener('keydown', escapeKeyHandler);
                } else {
                    lockBody();
                    document.addEventListener('keydown', escapeKeyHandler);
                }
            }

            function escapeKeyHandler(event) {
                if (event.key === 'Escape') {
                    stateSelectorModal.dataset.active = 'false';
                    unlockBody();
                    document.removeEventListener('keydown', escapeKeyHandler);
                }
            }

            if (target.matches('button[data-toggle-state-selector]') || target.parentElement?.matches('button[data-toggle-state-selector]')) {
                openCloseModal();
            }
        });
    }
});
